import { useSetAtom } from "jotai"
import { Button } from "~/components/ui/button"
import type { Plan } from "@apps/gwservice/types"
import { planApplicationAtom } from "../atoms/plan-application"

export function ApplicationButton({ plan }: { plan: Plan }) {
  const openApplication = useSetAtom(planApplicationAtom)
  const pending = plan.applicationStatus === "pending"

  return (
    <Button
      size="lg"
      className="!w-auto"
      disabled={pending}
      onClick={() => openApplication({ planId: plan.id })}
    >
      {pending ? "На рассмотрении" : "Подать заявку"}
    </Button>
  )
}
